import React, { ReactElement } from 'react';

interface IconOnlineApplicationsProps {
    color?: string;
    className?: string;
    title?: string;
}

export default function IconOnlineApplications({
    color = '#000000',
    className,
    title = 'New Car Application',
}: IconOnlineApplicationsProps): ReactElement {
    return (
        <svg
            width='20px'
            height='22px'
            viewBox='0 0 20 22'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            className={className}
        >
            <title>{title}</title>
            <g
                id='Eligibility-worklist-navigation'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <g
                    id='Eligibility-worklist-drop-down---Desktop'
                    transform='translate(-940.000000, -159.000000)'
                    stroke={color}
                    strokeWidth='2'
                >
                    <g id='Group' transform='translate(938.000000, 158.000000)'>
                        <g id='Group' transform='translate(3.000000, 2.000000)'>
                            <polyline id='Rectangle-2' points='0 16 0 2 0 2 14 2 14 16' />
                            <path
                                d='M0,16 C0,18.209139 1.790861,20 4,20 L4,20 C6.209139,20 8,18.209139 8,16'
                                id='Oval'
                            />
                            <path d='M14,20 L14,20 C16.209139,20 18,18.209139 18,16' id='Oval-Copy' />
                            <line x1='8' y1='16' x2='18' y2='16' id='Line' />
                            <line x1='14' y1='20' x2='4' y2='20' id='Line' />
                            <rect id='Rectangle-3' x='2' y='0' width='2' height='2' />
                            <rect id='Rectangle-3-Copy' x='10' y='0' width='2' height='2' />
                            <line x1='4' y1='7' x2='10' y2='7' id='Line' />
                            <line x1='4' y1='11' x2='10' y2='11' id='Line-Copy' />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
